<template>
  <a-avatar-group
    v-bind="attrs"
    :key="avatarKey"
    :class="[bem.b()]"
    :max-count="maxCount"
    :max-style="
      maxStyle ? maxStyle : { 'background-color': moreBg, color: moreColor }
    "
  >
    <slot>
      <template v-for="(item, index) in groupList" :key="index">
        <!-- 带文字提示 -->
        <ll-tooltip
          v-if="item.tooltip"
          :tip="item.tooltip"
          :container-style="{
            ...(index !== 0 &&
            (index <= getIndex ||
              !props.maxCount ||
              props.maxCount > groupList.length)
              ? { 'margin-inline-start': dynamicSpace + 'px' }
              : {}),
            ...(index === getIndex
              ? { 'margin-inline-end': dynamicSpace + 8 + 'px' }
              : {}),
          }"
          @mouseenter="handleHover(true, index)"
          @mouseleave="handleHover(false, -1)"
        >
          <ll-avatar
            v-bind="filterAtt(item)"
            :src="item.value"
            :icon="{ iconName: item.value, color: item.color }"
            :text="item.value"
            :style="{
              'background-color': item.backgroundColor,
              'border-color': item.borderColor,
              color: item.color,
            }"
            @click="handleAvatarClick(item, item.value, index)"
          />
        </ll-tooltip>
        <ll-avatar
          v-else
          v-bind="filterAtt(item)"
          :src="item.value"
          :icon="{ iconName: item.value, color: item.color }"
          :text="item.value"
          :style="{
            'background-color': item.backgroundColor,
            'border-color': item.borderColor,
            color: item.color,
            ...(index !== 0 &&
            (index <= getIndex ||
              !props.maxCount ||
              props.maxCount > groupList.length)
              ? { 'margin-inline-start': dynamicSpace + 'px' }
              : {}),
            ...(index === getIndex
              ? { 'margin-inline-end': dynamicSpace + 8 + 'px' }
              : {}),
          }"
          @click="handleAvatarClick(item, item.value, index)"
          @mouseenter="handleHover(true, index)"
          @mouseleave="handleHover(false, -1)"
        />
      </template>
    </slot>
  </a-avatar-group>
</template>
<script lang="ts" setup>
import { createNamespace } from '@ll-plus/utils'
import { computed, ref, useAttrs, watch } from 'vue'
import { avatarGroupProps } from './avatar'

// 1.defineOptions
defineOptions({ name: 'LlAvatarGroup' })

const attrs = useAttrs()

// 2.props/emits
const props = defineProps(avatarGroupProps)
const emits = defineEmits(['click', 'mouseenter', 'mouseleave'])

// 3.const
const bem = createNamespace('avatar-group')

const avatarKey = ref(0)

const isHovered = ref(false) // 悬停状态标识

const handleHover = (v: boolean, index: number) => {
  emits(v ? 'mouseenter' : 'mouseleave')
  if (getIndex.value !== -1 && index > getIndex.value) {
    return
  }

  if (props.useHover) {
    isHovered.value = v
  } else {
    isHovered.value = false
  }
}

const dynamicSpace = computed(() => {
  return isHovered.value ? 0 : props.avatarSpace
})

// 4.methods
const handleAvatarClick = (item: any, value: string, index: number) => {
  emits('click', item, value, index)
}

const filterAtt = (item: any) => {
  const newItem = { ...item }
  delete newItem.tooltip
  delete newItem.backgroundColor
  delete newItem.value
  delete newItem.borderColor
  delete newItem.color
  return newItem
}

// 获取“更多头像”前一位索引
const getIndex = computed(() => {
  if (0 < props.maxCount && props.maxCount <= props.groupList.length) {
    return props.maxCount - 1
  }
  return -1
})

watch([() => attrs.size, () => attrs.shape], () => {
  avatarKey.value++ // 改变key强制重新渲染
})
</script>
